export default __webpack_public_path__ + "static/media/location.e871e4cc.svg";